import { Core } from "@faire/design-tokens";
import { BrandRating } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageBrandReviewTile/__internal__/BrandRating";
import { IBrandReviewTile } from "@faire/web-api--source/indigofair/data/IBrandReviewTile";
import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

interface IProps {
  item: IBrandReviewTile;
}

export const BrandReview = ({
  item: { comment, location, retailer_name, brand_review_summary },
}: IProps) => {
  const { strictLocalize } = useStrictLocalization();
  const { isMobile } = useViewport();
  if (!brand_review_summary) {
    return null;
  }
  return (
    <>
      <Spacer height="2x" />
      <BrandRating brandReviewSummary={brand_review_summary} />
      {comment ? (
        <>
          <Spacer height="1x" />
          <Typography maxLines={isMobile ? 5 : 4}>
            {wrapStringInQuotes(comment, strictLocalize)}
          </Typography>
          <Spacer height="1x" />
          <Typography color={Core.text.subdued}>
            {`${retailer_name} (${location})`}
          </Typography>
        </>
      ) : null}
    </>
  );
};

const wrapStringInQuotes = (
  message: string,
  strictLocalize: StrictLocalizeFunction
) =>
  strictLocalize(
    {
      id: "RpKsQx",
      defaultMessage: "“{quoteAsFullyTranslatedSentence}”",
      description: {
        text: "Wrapping a message written by a brand or retailer in localized quotations",
      },
    },
    { quoteAsFullyTranslatedSentence: message }
  );
